
import { AiFillLike } from 'react-icons/ai';
import { AiTwotoneEye } from 'react-icons/ai';



export const behanceItem = [
    {
        
        fePatch: 'https://a5.behance.net/eb6198339b5bd9210ee85c5041d2da69b52ae5a5/img/galleries/icons/ribbons/1x/graphic-design.png?cb=264615658',
        featureImg: 'https://mir-s3-cdn-cf.behance.net/projects/max_808_webp/24806c126581961.Y3JvcCwxMzgwLDEwODAsMjU2LDA.jpg',
        featureTxt: 'Freeze-dried Cat Treats—Wanpy',
        feLike: '51',
        felikeIcons: <AiFillLike />,
        feWatch: '580',
        fewatchIcon: <AiTwotoneEye />,
        feUser: 'Reshoka'
    },
    {
        fePatch: 'https://a5.behance.net/eb6198339b5bd9210ee85c5041d2da69b52ae5a5/img/galleries/icons/ribbons/1x/graphic-design.png?cb=264615658',
        featureImg: 'https://mir-s3-cdn-cf.behance.net/projects/max_808_webp/bd803d118232193.Y3JvcCwyMDQ4LDE2MDEsMCwyMzM.png',
        featureTxt: 'Freeze-dried Cat Treats—Wanpy',
        feLike: '51',
        felikeIcons: <AiFillLike />,
        feWatch: '580',
        fewatchIcon: <AiTwotoneEye />,
        feUser: 'Reshoka'
    }, {
        fePatch: 'https://a5.behance.net/eb6198339b5bd9210ee85c5041d2da69b52ae5a5/img/galleries/icons/ribbons/1x/graphic-design.png?cb=264615658',
        featureImg: 'https://mir-s3-cdn-cf.behance.net/projects/max_808_webp/4468e2158061195.Y3JvcCw0MzE0LDMzNzUsMjg4LDA.jpg',
        featureTxt: 'Freeze-dried Cat Treats—Wanpy',
        feLike: '51',
        felikeIcons: <AiFillLike />,
        feWatch: '580',
        fewatchIcon: <AiTwotoneEye />,
        feUser: 'Reshoka'
    }, {
        fePatch: 'https://a5.behance.net/eb6198339b5bd9210ee85c5041d2da69b52ae5a5/img/galleries/icons/ribbons/1x/graphic-design.png?cb=264615658',
        featureImg: 'https://mir-s3-cdn-cf.behance.net/projects/max_808_webp/336c6a157572517.Y3JvcCwxMDgwLDg0NCwwLDExNw.jpg',
        featureTxt: 'Freeze-dried Cat Treats—Wanpy',
        feLike: '51',
        felikeIcons: <AiFillLike />,
        feWatch: '580',
        fewatchIcon: <AiTwotoneEye />,
        feUser: 'Reshoka'
    }, {
        fePatch: 'https://a5.behance.net/eb6198339b5bd9210ee85c5041d2da69b52ae5a5/img/galleries/icons/ribbons/1x/graphic-design.png?cb=264615658',
        featureImg: 'https://mir-s3-cdn-cf.behance.net/projects/max_808_webp/55a92a152718637.Y3JvcCwxMTkyLDkzMywxMzIsMA.jpg',
        featureTxt: 'Freeze-dried Cat Treats—Wanpy',
        feLike: '51',
        felikeIcons: <AiFillLike />,
        feWatch: '580',
        fewatchIcon: <AiTwotoneEye />,
        feUser: 'Reshoka'
    },
    {
        fePatch: 'https://a5.behance.net/eb6198339b5bd9210ee85c5041d2da69b52ae5a5/img/galleries/icons/ribbons/1x/graphic-design.png?cb=264615658',
        featureImg: 'https://mir-s3-cdn-cf.behance.net/projects/max_808_webp/653e56158206595.638784064021f.jpg',
        featureTxt: 'Freeze-dried Cat Treats—Wanpy',
        feLike: '51',
        felikeIcons: <AiFillLike />,
        feWatch: '580',
        fewatchIcon: <AiTwotoneEye />,
        feUser: 'Reshoka'
    }, {
        fePatch: 'https://a5.behance.net/eb6198339b5bd9210ee85c5041d2da69b52ae5a5/img/galleries/icons/ribbons/1x/graphic-design.png?cb=264615658',
        featureImg: 'https://mir-s3-cdn-cf.behance.net/projects/max_808_webp/4468e2158061195.Y3JvcCw0MzE0LDMzNzUsMjg4LDA.jpg',
        featureTxt: 'Freeze-dried Cat Treats—Wanpy',
        feLike: '51',
        felikeIcons: <AiFillLike />,
        feWatch: '580',
        fewatchIcon: <AiTwotoneEye />,
        feUser: 'Reshoka'
    },
    {
        fePatch: 'https://a5.behance.net/eb6198339b5bd9210ee85c5041d2da69b52ae5a5/img/galleries/icons/ribbons/1x/graphic-design.png?cb=264615658',
        featureImg: 'https://mir-s3-cdn-cf.behance.net/projects/max_808_webp/4a6005132419475.Y3JvcCw4MDgsNjMyLDAsMA.jpg',
        featureTxt: 'Freeze-dried Cat Treats—Wanpy',
        feLike: '51',
        felikeIcons: <AiFillLike />,
        feWatch: '580',
        fewatchIcon: <AiTwotoneEye />,
        feUser: 'Reshoka'
    },
    {
        fePatch: 'https://a5.behance.net/eb6198339b5bd9210ee85c5041d2da69b52ae5a5/img/galleries/icons/ribbons/1x/graphic-design.png?cb=264615658',
        featureImg: 'https://mir-s3-cdn-cf.behance.net/projects/max_808_webp/aadca8140674779.Y3JvcCwxMzgwLDEwODAsMjQyLDA.jpg',
        featureTxt: 'Freeze-dried Cat Treats—Wanpy',
        feLike: '51',
        felikeIcons: <AiFillLike />,
        feWatch: '580',
        fewatchIcon: <AiTwotoneEye />,
        feUser: 'Reshoka'
    },
    {
        fePatch: 'https://a5.behance.net/eb6198339b5bd9210ee85c5041d2da69b52ae5a5/img/galleries/icons/ribbons/1x/graphic-design.png?cb=264615658',
        featureImg: 'https://mir-s3-cdn-cf.behance.net/projects/max_808_webp/aadca8140674779.Y3JvcCwxMzgwLDEwODAsMjQyLDA.jpg',
        featureTxt: 'Freeze-dried Cat Treats—Wanpy',
        feLike: '51',
        felikeIcons: <AiFillLike />,
        feWatch: '580',
        fewatchIcon: <AiTwotoneEye />,
        feUser: 'Reshoka'
    },
    {
        fePatch: 'https://a5.behance.net/eb6198339b5bd9210ee85c5041d2da69b52ae5a5/img/galleries/icons/ribbons/1x/graphic-design.png?cb=264615658',
        featureImg: 'https://mir-s3-cdn-cf.behance.net/projects/max_808_webp/24806c126581961.Y3JvcCwxMzgwLDEwODAsMjU2LDA.jpg',
        featureTxt: 'Freeze-dried Cat Treats—Wanpy',
        feLike: '51',
        felikeIcons: <AiFillLike />,
        feWatch: '580',
        fewatchIcon: <AiTwotoneEye />,
        feUser: 'Reshoka'
    },
    {
        fePatch: 'https://a5.behance.net/eb6198339b5bd9210ee85c5041d2da69b52ae5a5/img/galleries/icons/ribbons/1x/graphic-design.png?cb=264615658',
        featureImg: 'https://mir-s3-cdn-cf.behance.net/projects/max_808_webp/a08655129351935.Y3JvcCw5OTQsNzc4LDIyLDA.png',
        featureTxt: 'Freeze-dried Cat Treats—Wanpy',
        feLike: '51',
        felikeIcons: <AiFillLike />,
        feWatch: '580',
        fewatchIcon: <AiTwotoneEye />,
        feUser: 'Reshoka'
    },
    {
        fePatch: 'https://a5.behance.net/eb6198339b5bd9210ee85c5041d2da69b52ae5a5/img/galleries/icons/ribbons/1x/graphic-design.png?cb=264615658',
        featureImg: '    https://mir-s3-cdn-cf.behance.net/projects/max_808_webp/4a6005132419475.Y3JvcCw4MDgsNjMyLDAsMA.jpg',
        featureTxt: 'Freeze-dried Cat Treats—Wanpy',
        feLike: '51',
        felikeIcons: <AiFillLike />,
        feWatch: '580',
        fewatchIcon: <AiTwotoneEye />,
        feUser: 'Reshoka'
    },
    {
        fePatch: 'https://a5.behance.net/eb6198339b5bd9210ee85c5041d2da69b52ae5a5/img/galleries/icons/ribbons/1x/graphic-design.png?cb=264615658',
        featureImg: 'https://mir-s3-cdn-cf.behance.net/projects/max_808_webp/15b0fc157771815.Y3JvcCwxMTQzLDg5NCwxMjcsMjU.png',
        featureTxt: 'Freeze-dried Cat Treats—Wanpy',
        feLike: '51',
        felikeIcons: <AiFillLike />,
        feWatch: '580',
        fewatchIcon: <AiTwotoneEye />,
        feUser: 'Reshoka'
    },
    {
        fePatch: 'https://a5.behance.net/eb6198339b5bd9210ee85c5041d2da69b52ae5a5/img/galleries/icons/ribbons/1x/graphic-design.png?cb=264615658',
        featureImg: 'https://mir-s3-cdn-cf.behance.net/projects/max_808_webp/55a92a152718637.Y3JvcCwxMTkyLDkzMywxMzIsMA.jpg',
        featureTxt: 'Freeze-dried Cat Treats—Wanpy',
        feLike: '51',
        felikeIcons: <AiFillLike />,
        feWatch: '580',
        fewatchIcon: <AiTwotoneEye />,
        feUser: 'Reshoka'
    },
]